import React from "react";
import Routes from "./routes";
import { ChecklistProvider } from "./context/checklistContext";
import { PentagovProvider } from "./context/pentagovContext";
import { AuthProvider } from "./context/authContext";
import AuthLoader from "./Componentes/AuthLoader";

export default function App() {
  return (
    <PentagovProvider>
      <AuthProvider>
        <ChecklistProvider>
          <AuthLoader>
            <Routes />
          </AuthLoader>
        </ChecklistProvider>
      </AuthProvider>
    </PentagovProvider>
  );
}
